<section class="report-summary-header">
	<div class="report-summary-main">
		<div class="report-title-area">
			<h2>{{ title }}</h2>

			<div class="report-business-date" *ngIf="businessDateText">
				<span class="label">{{ businessDateLabel }}:</span>
				<span class="value">{{ businessDateText }}</span>
			</div>
		</div>
	</div>

	<div
		class="report-header-controls"
		*ngIf="snippets.length || actionLabel"
	>
		<div class="report-snippets" *ngIf="snippets.length">
			<div
				class="report-snippet"
				*ngFor="let snippet of snippets"
				[ngClass]="getSnippetToneClass(snippet)"
			>
				<div class="snippet-label">{{ snippet.label }}</div>

				<div class="snippet-value">
					{{ snippet.value }}

					<span class="snippet-suffix" *ngIf="snippet.suffix">
               {{ snippet.suffix }}
            </span>
				</div>
			</div>
		</div>

		<button
			*ngIf="actionLabel"
			type="button"
			class="report-header-action"
			[disabled]="actionDisabled"
			(click)="onActionRequested()"
		>
			{{ actionLabel }}
		</button>
	</div>
</section>
